<template>
    <div class="common-bannner-container">
        <div :class="['banner-main-body', classList[pageName], className]">
            <div class="banner-text">
                <!-- 金融超市 -->
                <template v-if="pageName === 'FINANCIAL'">
                    <div class="container">
                        <template v-if="['financial'].includes($route.name)">
                            <el-input
                                v-model="filterPorductKeyWords"
                                placeholder="请输入银行名称、机构名称"
                                class="filter-org-input"
                                @keyup.enter.native="financeSupermarket"
                            >
                            </el-input>
                            <el-button
                                class="btn-item search-btn"
                                type="primary"
                                icon="el-icon-search"
                                @click="financeSupermarket"
                                >搜索</el-button
                            >
                        </template>
                    </div>
                </template>
                <!-- 特色专区 -->
                <template v-else-if="pageName === 'CHARACTERISTICAREA'">
                    <div class="container">
                        <template v-if="className == 'characteristicArea'">
                        </template>
                        <template v-else-if="className == 'revitalization'">
                        </template>
                        <template v-else-if="className == 'benefitEnt'">
                        </template>
                        <template v-else-if="className == 'gardenArea'">
                            <h3 class="zh-title">
                                <span>场景金融</span>
                            </h3>
                        </template>
                        <template v-else-if="className == 'article'">
                            <h3 class="zh-title">
                                <!-- <span>五篇大文章</span> -->
                            </h3>
                        </template>
                        <template v-else-if="className == 'articleInfoTechfin'">
                            <h3 class="zh-title">
                                <span>科技金融</span>
                            </h3>
                        </template>
                        <template v-else-if="className == 'rosterPublicity'">
                            <h3 class="zh-title">
                                <span>名单公示</span>
                            </h3>
                        </template>
                        <template v-else-if="className == 'articleInfoInclusive'">
                            <h3 class="zh-title">
                                <span>普惠金融</span>
                            </h3>
                        </template>
                        <template v-else-if="className == 'laibai_info'">
                            <h3 class="zh-title">
                                <span>兰白专区</span>
                            </h3>
                        </template>
                        <template v-else-if="className == 'articleInfoAnnuity'">
                            <h3 class="zh-title">
                                <span>养老金融</span>
                            </h3>
                        </template>
                        <template v-else-if="className == 'articleInfoNumber'">
                            <h3 class="zh-title">
                                <span>数字金融</span>
                            </h3>
                        </template>
                        <template v-else-if="className == 'yhPromotionZone'">
                            <h3 class="zh-title">
                                <span>优惠推广专区</span>
                            </h3>
                        </template>
                        <template v-else>
                            <h3 class="zh-title">
                                <span>财政+金融</span>
                            </h3>
                        </template>
                    </div>
                </template>
                <!-- 项目信息 -->
                <template v-else-if="pageName === 'PROJECTINFO'">
                    <div class="container">
                        <template>
                            <el-input
                                v-model="filterPorductKeyWords"
                                placeholder="请输入项目信息"
                                class="filter-org-input"
                                @keyup.enter.native="searchPolicy"
                            >
                            </el-input>
                            <el-button
                                class="btn-item search-btn"
                                type="primary"
                                icon="el-icon-search"
                                @click="searchPolicy"
                                >搜索</el-button
                            >
                        </template>
                    </div>
                </template>

                <!-- 首贷中心 -->
                <template v-else-if="pageName === 'LOAN'">
                    <div class="container">
                        <template>
                            <div class="loan-data-box">
                                <el-row :gutter="18">
                                    <el-col
                                        :span="8"
                                        :class="['box-con', `box-con-${index}`]"
                                        v-for="(item, index) in argDatas"
                                        :key="`box-con-item-${index}`"
                                    >
                                        <!-- <div class="con-icon"></div> -->
                                        <div class="con-text">
                                            <div class="text-label">
                                                {{ item.label }}
                                            </div>
                                            <div class="text-val">
                                                <CountTo
                                                    :startVal="0"
                                                    :endVal="item.value"
                                                    :duration="2500"
                                                    :decimals="item.decimals"
                                                />
                                                <span class="text-unit">{{
                                                    item.unit
                                                }}</span>
                                            </div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </template>
                    </div>
                </template>
                <!-- 政策速递 -->
                <template v-else-if="pageName === 'POLICY'">
                    <div class="container">
                        <!-- <template v-if="$route.path !== '/policy'"> -->
                        <template
                            v-if="
                                ![
                                    '/policy',
                                    '/policyDetail',
                                    '/newsDetail',
                                    '/activityDetail',
                                ].includes($route.path)
                            "
                        >
                            <!-- <p>政策激励、信用培育、多方应用</p> -->
                            <div class="input-box">
                                <el-input
                                    placeholder="请输入关键词"
                                    v-model="filterPorductKeyWords"
                                    @keyup.enter.native="onPolicyClick"
                                >
                                    <!-- <template slot="append">
                                        <i @click="onPolicyClick" class="el-icon-search"></i>
                                    </template> -->
                                </el-input>
                                <el-button
                                    class="btn-item search-btn"
                                    type="primary"
                                    icon="el-icon-search"
                                    @click="onPolicyClick"
                                    >搜索</el-button
                                >
                            </div>
                        </template>
                    </div>
                </template>
                <!-- 统计中心 -->
                <template v-else-if="pageName === 'STATISTICS'">
                    <div class="container">
                        <template v-if="$route.path != '/statistics'">
                            <!-- <p>政策激励、信用培育、多方应用</p> -->
                            <div class="input-box"></div>
                        </template>
                    </div>
                </template>
                <!-- 智慧政策 -->
                <template v-else-if="pageName === 'SMARTPOLICY'">
                    <div class="container">
                        <template>
                            <el-input
                                v-model="filterPorductKeyWords"
                                placeholder="请输入政策关键字"
                                class="filter-org-input"
                                @keyup.enter.native="searchSmartPolicy"
                            >
                            </el-input>
                            <el-button
                                class="btn-item search-btn"
                                type="primary"
                                icon="el-icon-search"
                                @click="searchSmartPolicy"
                                >搜索</el-button
                            >
                        </template>
                    </div>
                </template>
                <!-- 企业规模测算 -->
                <template v-else-if="pageName === 'ENTSCALE'">
                    <div class="container">
                        <template> </template>
                    </div>
                </template>

                <!-- 中介机构 -->
                <template v-else-if="pageName === 'AGENCY'">
                    <div class="container">
                        <template> </template>
                    </div>
                </template>

                <!-- 企业培训 -->
                <template v-else-if="pageName === 'ENTFOSTER'">
                    <div class="container">
                        <template>
                            <el-input
                                v-model="filterPorductKeyWords"
                                placeholder="请输入服务名称"
                                class="filter-org-input"
                                @keyup.enter.native="searchPolicy"
                            >
                            </el-input>
                            <el-button
                                class="btn-item search-btn"
                                type="primary"
                                icon="el-icon-search"
                                @click="searchPolicy"
                                >搜索</el-button
                            >
                        </template>
                    </div>
                </template>
                <!-- 企业培训 -->
                <template v-else-if="pageName === 'SERVEHALL'">
                    <div class="container">
                        <h3 class="zh-title">
                            <!-- <span>信用服务</span> -->
                        </h3>
                    </div>
                </template>
            </div>
            <template v-if="breadcrumb.length !== 0">
                <div class="banner-breadcrumb">
                    <div class="container">
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <span>当前位置：</span>
                            <!-- :to="{ path: item.locationHref && item.locationHref !== '' ? item.locationHref : '' }" -->
                            <el-breadcrumb-item
                                v-for="(item, index) in breadcrumb"
                                :key="`breadcrumb-item-${index}`"
                            >
                                <span
                                    @click="pageJump(item.locationHref)"
                                    style="color: #fff"
                                    >{{ item.name }}</span
                                >
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import CountTo from "vue-count-to";
import { isParamEmpty } from "../filters";
import { getToken } from "@/utils/auth";
export default {
    name: "commonBannerPage",
    components: { CountTo },
    props: {
        pageName: {
            type: String,
            default: () => {
                return "";
            },
            required: true,
        }, // 页面类型 String（金融机构 - FINANCIAL、金融产品 - PRODUCT、首贷中心 - LOAN、新闻资讯 - NEWS、关于我们 - ABOUT、帮助中心 - HELP）
        breadcrumb: {
            type: Array,
            default: () => {
                return [];
            },
            required: true,
        }, // 面包屑导航 Array（[{ name: "帮助中心", locationHref: "" }] - 导航名称 name、导航地址 locationHref）
        otherData: {
            type: Object,
            default: () => {
                return {};
            },
            required: false,
        }, // 额外数据 Object （类似首贷中心统计数）
        className: {
            type: String,
            default: () => {
                return "";
            },
            required: false,
        },
        argDatas: {
            type: [String, Array, Object, Boolean, Number],
            default: () => {
                return null;
            },
            required: false,
        },
        keywords: {
            type: String,
            default: () => {
                return "";
            },
            required: false,
        },
    },
    watch: {
        pageName: {
            deep: true,
            handler(newVal, oldVal) {
                this.pageName = oldVal !== newVal ? newVal : oldVal;
            },
            immediate: true,
        },
        breadcrumb: {
            deep: true,
            handler(newVal, oldVal) {
                // this.bannerChange();
                this.breadcrumb = oldVal !== newVal ? newVal : oldVal;
            },
            immediate: true,
        },
        // filterPorductKeyWords: {
        //     handler: function(newVal, oldVal) {
        //         this.filterPorductKeyWords = oldVal !== newVal ? newVal : oldVal;
        //     }
        // }
    },
    data() {
        return {
            filterPorductKeyWords: "",
            classList: {
                FINANCIAL: "financial-container",
                PROJECTINFO: "projectInfo",
                CHARACTERISTICAREA: "characteristicArea",
                FLOODDEFENSE:"flooddefense",
                STATISTICS: "statistics",
                POLICY: "policy-container",
                SMARTPOLICY: "smartPolicy",
                LOAN: "loan-container",
            },
            policyName: "",
            servicName: "",
            featureName: "",
            description: "",
            url: "",
        };
    },
    created() {
        this.$data.filterPorductKeyWords = this.keywords;
    },
    methods: {
        pageJump(jumpUrl) {
            if (!isParamEmpty(jumpUrl)) {
                if (["IndexBjfw"].includes(jumpUrl)) {
                    window.sessionStorage.setItem("indexPosition", jumpUrl);
                    this.$router.push({ path: "/" });
                } else {
                    this.$router.push({ path: jumpUrl });
                }
            }
        },

        // 智能政策匹配
        searchSmartPolicy() {
            this.$EventBus.$emit(
                "searchSmartPolicy",
                this.filterPorductKeyWords
            );
        },
        // 金融超市
        financeSupermarket() {
            this.$EventBus.$emit(
                "financeSupermarket",
                this.filterPorductKeyWords
            );
        },

        // 项目信息
        onPolicyClick() {
            this.$EventBus.$emit("onPolicyClick", this.filterPorductKeyWords);
        },

        // 关键字搜索
        searchPolicy() {
            this.$EventBus.$emit("searchPolicy", this.filterPorductKeyWords);
        },
    },
};
</script>

<style lang="scss">
.common-bannner-container {
    background-size: 100% 100% !important;
    .el-breadcrumb__inner {
        color: #666 !important;
        font-weight: bold !important;
        cursor: pointer !important;
    }

    .el-breadcrumb__item {
        &:last-child .el-breadcrumb__inner {
            cursor: default !important;
        }
    }
    .el-icon-refresh-right {
        font-size: 20px;
    }
}
</style>

<style lang="scss" scoped>
.common-bannner-container {
    background-size: 100% 100% !important;
    // 公用 bannner 样式
    .banner-main-body {
        position: relative;
        height: 300px;
    }

    .banner-breadcrumb {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(21, 25, 48, 0.6);
    }

    .el-breadcrumb {
        position: relative;
        color: #fff;
        font-size: 16px;
        // font-weight: bold;
        height: 40px;
        line-height: 40px;
        padding-left: 30px;

        &::before {
            content: "";
            width: 20px;
            height: 20px;
            position: absolute;
            top: 7px;
            left: 0;
            background: url("./../assets/xyd/bannerImg/breadcrumb-home.png")
                no-repeat center center;
            background-size: 100% 100%;
        }
    }

    .el-breadcrumb__item {
        >>> {
            float: none;
        }
    }

    .btn-item {
        height: 60px;
        margin-left: 0px;
        font-size: 20px;
    }

    // 金融超市
    .financial-container {
        //background-image: url("./../assets/xyd/bannerImg/banner-01.jpg");
        background: url("/static/img/banner-01.avif") no-repeat
            center center;
        background-size: 100% 100%;

        &.financial-detail {
            // background: url("./../assets/bannerImg/financial-detail-banner.png")
            //     no-repeat center center;
            background-size: 100% 100%;
        }

        .banner-text {
            .container {
                height: 260px;
                display: flex;
                // flex-direction: column;
                justify-content: center;
                align-items: center;
            }
        }

        .filter-org-input {
            width: 43%;
            // margin: 0 auto;
            >>> .el-input__inner {
                height: 60px;
                line-height: 60px;
                color: #666;
                font-size: 22px;
                border-color: #666;
                // border-right-color: transparent;
                // background-color: transparent;

                &:focus {
                    border-color: #666 !important;
                    // border-right-color: transparent !important;
                }

                &::placeholder {
                    color: #666;
                    font-size: 22px;
                }
            }

            >>> .el-input-group__append {
                position: relative;
                background-color: transparent;
                border-color: #666;
                cursor: pointer;

                &::before {
                    content: "";
                    position: absolute;
                    display: inline-block;
                    height: 30px;
                    width: 1px;
                    top: 15px;
                    left: 0;
                    background-color: #666;
                }

                .el-icon-search {
                    color: #666;
                    font-size: 24px;
                }
            }
        }
    }
    // 特色专区
    .characteristicArea {
       // background: url("./../assets/xyd/bannerImg/banner-02.png") no-repeat
        background: url("/static/img/banner-02.avif") no-repeat
            center center;
        background-size: 100% 100%;
        .banner-text {
            .container {
                height: 260px;
                display: flex;
                // flex-direction: column;
                justify-content: center;
                align-items: center;
            }
        }
        .container {
            .filter-org-input {
                width: 43%;
                // margin: 0 auto;
                >>> .el-input__inner {
                    height: 60px;
                    line-height: 60px;
                    color: #666;
                    font-size: 22px;
                    border-color: #666;
                    // border-right-color: transparent;
                    // background-color: transparent;

                    &:focus {
                        border-color: #666 !important;
                        // border-right-color: transparent !important;
                    }

                    &::placeholder {
                        color: #666;
                        font-size: 22px;
                    }
                }

                >>> .el-input-group__append {
                    position: relative;
                    background-color: transparent;
                    border-color: #666;
                    cursor: pointer;

                    &::before {
                        content: "";
                        position: absolute;
                        display: inline-block;
                        height: 30px;
                        width: 1px;
                        top: 15px;
                        left: 0;
                        background-color: #666;
                    }

                    .el-icon-search {
                        color: #666;
                        font-size: 24px;
                    }
                }
            }
        }
    }
    // 特色专区
    .flooddefense {
        background: url("./../assets/xyd/bannerImg/banner-fxjz.png") no-repeat
        center center;
        background-size: 100% 100%;
        .banner-text {
            .container {
                height: 260px;
                display: flex;
                // flex-direction: column;
                justify-content: center;
                align-items: center;
            }
        }
        .container {
            .filter-org-input {
                width: 43%;
                // margin: 0 auto;
                >>> .el-input__inner {
                    height: 60px;
                    line-height: 60px;
                    color: #666;
                    font-size: 22px;
                    border-color: #666;
                    // border-right-color: transparent;
                    // background-color: transparent;

                    &:focus {
                        border-color: #666 !important;
                        // border-right-color: transparent !important;
                    }

                    &::placeholder {
                        color: #666;
                        font-size: 22px;
                    }
                }

                >>> .el-input-group__append {
                    position: relative;
                    background-color: transparent;
                    border-color: #666;
                    cursor: pointer;

                    &::before {
                        content: "";
                        position: absolute;
                        display: inline-block;
                        height: 30px;
                        width: 1px;
                        top: 15px;
                        left: 0;
                        background-color: #666;
                    }

                    .el-icon-search {
                        color: #666;
                        font-size: 24px;
                    }
                }
            }
        }
    }
    .financialZone {
        background: url("./../assets/xyd/bannerImg/banner-02-01.png") no-repeat
            center center;
        background-size: 100% 100%;
        .zh-title {
            font-size: 60px;
            font-weight: bold;
            color: #ffffff;
            line-height: 35px;
            text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.8);
        }
    }
    .specializedNew {
        background: url("./../assets/xyd/bannerImg/banner-02-01.png") no-repeat
            center center;
        background-size: 100% 100%;
        .zh-title {
            font-size: 60px;
            font-weight: bold;
            color: #ffffff;
            line-height: 35px;
            text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.8);
        }
    }
    .revitalization {
        background: url("./../assets/xyd/bannerImg/banner-10.png") no-repeat
            center center;
        background-size: 100% 100%;
    }
    .benefitEnt {
        background: url("./../assets/xyd/bannerImg/banner-11.png") no-repeat
            center center;
        background-size: 100% 100%;
    }
    .gardenArea {
        background: url("./../assets/xyd/bannerImg/banner-14.png") no-repeat
            center center;
        background-size: 100% 100%;
        .zh-title {
            font-weight: bold;
            font-size: 60px;
            color: #ffffff;
            text-shadow: 0px 2px 2px rgba(1, 42, 109, 0.5);
        }
    }
    .article {
        background: url("./../assets/xyd/bannerImg/banner-16.png") no-repeat
            center center;
        background-size: 100% 100%;
        .zh-title {
            font-weight: bold;
            font-size: 60px;
            color: #ffffff;
            text-shadow: 0px 2px 2px rgba(1, 42, 109, 0.5);
        }
    }
    .articleInfoTechfin {
        background: url("./../assets/xyd/bannerImg/banner-17.png") no-repeat
            center center;
        background-size: 100% 100%;
        .zh-title {
            font-weight: bold;
            font-size: 60px;
            color: #ffffff;
            text-shadow: 0px 2px 2px rgba(1, 42, 109, 0.5);
        }
    }
    .rosterPublicity {
        background: url("./../assets/xyd/bannerImg/banner-21.png") no-repeat
            center center;
        background-size: 100% 100%;
        .zh-title {
            font-weight: bold;
            font-size: 60px;
            color: #ffffff;
            text-shadow: 0px 2px 2px rgba(1, 42, 109, 0.5);
        }
    }
    .articleInfoInclusive, .laibai_info {
        background: url("./../assets/xyd/bannerImg/banner-18.png") no-repeat
            center center;
        background-size: 100% 100%;
        .zh-title {
            font-weight: bold;
            font-size: 60px;
            color: #ffffff;
            text-shadow: 0px 2px 2px rgba(1, 42, 109, 0.5);
        }
    }
    .articleInfoAnnuity {
        background: url("./../assets/xyd/bannerImg/banner-19.png") no-repeat
            center center;
        background-size: 100% 100%;
        .zh-title {
            font-weight: bold;
            font-size: 60px;
            color: #ffffff;
            text-shadow: 0px 2px 2px rgba(1, 42, 109, 0.5);
        }
    }
    .articleInfoNumber {
        background: url("./../assets/xyd/bannerImg/banner-20.png") no-repeat
            center center;
        background-size: 100% 100%;
        .zh-title {
            font-weight: bold;
            font-size: 60px;
            color: #ffffff;
            text-shadow: 0px 2px 2px rgba(1, 42, 109, 0.5);
        }
    }
    .yhPromotionZone {
        background: url("./../assets/xyd/bannerImg/banner-02-01.png") no-repeat
            center center;
        background-size: 100% 100%;
        .zh-title {
            font-weight: bold;
            font-size: 60px;
            color: #ffffff;
            text-shadow: 0px 2px 2px rgba(1, 42, 109, 0.5);
        }
    }
    // 项目信息
    .projectInfo {
        //background: url("./../assets/xyd/bannerImg/banner-03.png") no-repeat
        background: url("/static/img/banner-03.avif") no-repeat
            center center;
        background-size: 100% 100%;
        .banner-text {
            .container {
                height: 260px;
                display: flex;
                // flex-direction: column;
                justify-content: center;
                align-items: center;
            }
        }
        .container {
            .filter-org-input {
                width: 43%;
                // margin: 0 auto;
                >>> .el-input__inner {
                    height: 60px;
                    line-height: 60px;
                    color: #666;
                    font-size: 22px;
                    border-color: #666;
                    // border-right-color: transparent;
                    // background-color: transparent;

                    &:focus {
                        border-color: #666 !important;
                        // border-right-color: transparent !important;
                    }

                    &::placeholder {
                        color: #666;
                        font-size: 22px;
                    }
                }

                >>> .el-input-group__append {
                    position: relative;
                    background-color: transparent;
                    border-color: #666;
                    cursor: pointer;

                    &::before {
                        content: "";
                        position: absolute;
                        display: inline-block;
                        height: 30px;
                        width: 1px;
                        top: 15px;
                        left: 0;
                        background-color: #666;
                    }

                    .el-icon-search {
                        color: #666;
                        font-size: 24px;
                    }
                }
            }
        }
    }

    // 首贷中心
    .loan-container {
        background: url("/static/img/banner-15.avif") no-repeat;
        //background: url("./../assets/xyd/bannerImg/banner-15.png") no-repeat;
        //     center center;
        background-size: 100% 100%;
        .banner-text .container {
            height: 260px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .loan-data-box {
            width: 1200px;
            height: 130px;
            border-radius: 10px;
            background: rgba($color: #ffffff, $alpha: 1);
            position: absolute;
            top: 230px;
        }

        .box-con {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 130px;

            // .con-icon {
            //     width: 45px;
            //     height: 45px;
            // }
            .con-text {
                // margin-left: 10px;
                text-align: center;
                .text-label {
                    color: #000000;
                    font-size: 20px;
                    font-weight: bold;
                    margin-bottom: 10px;
                }
                .text-val {
                    color: #ca2600;
                    font-size: 32px;
                    font-weight: bold;
                }
                .text-unit {
                    color: #000000;
                    font-size: 18px;
                }
            }
        }
    }
    // 陇信服务大厅
    .serveHall {
        background: url("/static/img/banner-05.avif") no-repeat
        //background: url("./../assets/xyd/bannerImg/banner-05.png") no-repeat
            center center;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .container {
            .zh-title {
                font-weight: bold;
                font-size: 60px;
                color: #ffffff;
                text-shadow: 0px 2px 2px rgba(1, 42, 109, 0.5);
                text-align: center;
            }
        }
    }

    // 政策速递
    .policy-container {
        background: url("/static/img/banner-06.avif") no-repeat
        //background: url("./../assets/xyd/bannerImg/banner-06.png") no-repeat
            center center;
        background-size: 100% 100%;

        .banner-text {
            .container {
                height: 260px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                text-align: center;
                width: 800px;
                p {
                    font-size: 40px;
                    font-weight: bold;
                    color: #666;
                }
                .input-box {
                    display: flex;
                    .el-input {
                        margin-top: 20px;
                        flex: 1;
                        width: 792px;
                        >>> .el-input__inner {
                            background-color: #fff;
                            border-color: #666;
                            // border-right: none;
                            color: #666;
                            height: 60px;
                            font-size: 22px;
                            &::-webkit-input-placeholder {
                                color: #666;
                            }
                            &:focus {
                                border-color: #666;
                            }
                        }
                        >>> .el-input-group__append {
                            position: relative;
                            background-color: #fff;
                            border-color: #666;
                            color: #666;
                            cursor: pointer;
                            &::before {
                                position: absolute;
                                content: " ";
                                height: 30px;
                                width: 1px;
                                background: #fff;
                                left: 0;
                                display: inline-block;
                                top: 15px;
                            }
                        }

                        >>> .el-icon-search {
                            font-size: 24px;
                        }
                    }
                    .btn-item {
                        margin-top: 20px;
                    }
                }
            }
        }
    }

    // 统计中心
    .statistics {
        background: url("./../assets/xyd/bannerImg/banner-07.png") no-repeat
            center center;
        background-size: 100% 100%;
        .banner-text {
            .container {
                height: 300px;
                display: flex;
                flex-direction: column;
                justify-content: center;
            }
        }
    }

    // 智慧政策
    .smartPolicy {
        background: url("./../assets/xyd/bannerImg/banner-08.jpg") no-repeat
            center center;
        background-size: 100% 100%;
        .banner-text {
            .container {
                height: 260px;
                display: flex;
                // flex-direction: column;
                justify-content: center;
                align-items: center;
            }
        }
        .filter-org-input {
            width: 43%;
            // margin: 0 auto;
            >>> .el-input__inner {
                height: 60px;
                line-height: 60px;
                color: #666;
                font-size: 22px;
                border-color: #666;
                // border-right-color: transparent;
                // background-color: transparent;

                &:focus {
                    border-color: #666 !important;
                    // border-right-color: transparent !important;
                }

                &::placeholder {
                    color: #666;
                    font-size: 22px;
                }
            }

            >>> .el-input-group__append {
                position: relative;
                background-color: transparent;
                border-color: #666;
                cursor: pointer;

                &::before {
                    content: "";
                    position: absolute;
                    display: inline-block;
                    height: 30px;
                    width: 1px;
                    top: 15px;
                    left: 0;
                    background-color: #666;
                }

                .el-icon-search {
                    color: #666;
                    font-size: 24px;
                }
            }
        }
    }

    // 智慧政策
    .entScale {
        background: url("./../assets/xyd/bannerImg/banner-09.png") no-repeat
            center center;
        background-size: 100% 100%;
    }

    // 中介服务
    .agency {
        background: url("./../assets/xyd/bannerImg/banner-12.png") no-repeat
            center center;
        background-size: 100% 100%;
    }

    // 企业培育
    .entFoster {
        background: url("./../assets/xyd/bannerImg/banner-13.png") no-repeat
            center center;
        background-size: 100% 100%;
        .banner-text {
            .container {
                height: 260px;
                display: flex;
                // flex-direction: column;
                justify-content: center;
                align-items: center;
            }
        }
        .filter-org-input {
            width: 43%;
            // margin: 0 auto;
            >>> .el-input__inner {
                height: 60px;
                line-height: 60px;
                color: #666;
                font-size: 22px;
                border-color: #666;
                // border-right-color: transparent;
                // background-color: transparent;

                &:focus {
                    border-color: #666 !important;
                    // border-right-color: transparent !important;
                }

                &::placeholder {
                    color: #666;
                    font-size: 22px;
                }
            }

            >>> .el-input-group__append {
                position: relative;
                background-color: transparent;
                border-color: #666;
                cursor: pointer;

                &::before {
                    content: "";
                    position: absolute;
                    display: inline-block;
                    height: 30px;
                    width: 1px;
                    top: 15px;
                    left: 0;
                    background-color: #666;
                }

                .el-icon-search {
                    color: #666;
                    font-size: 24px;
                }
            }
        }
    }

    // *********************************************************************************************************************
}
</style>



// WEBPACK FOOTER //
// src/components/PageBanner.vue